import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useGetContract, useGetContractExport } from './hooks/api/contractsApi';
import { BLACK } from '../../constants/colors';
import ContractRouter from '../../router/ContractRouter';
import ContentLoader from '../../components/ContentLoader';
import FileExport from '../../components/FileExport/FileExport';
import Container from '@material-ui/core/Container';
import { FormattedMessage, useIntl } from 'react-intl';

const StyledHeader = styled.div`
  vertical-align: middle;
  color: ${BLACK};
  & > h1 {
    font-size: 28px;
    margin: 0;
    text-transform: uppercase;
  }
  & > h2 {
    font-size: 24px;
    font-weight: normal;
    margin: 0;
  }
`;

const Contract = (props) => {
  const intl = useIntl();
  const tabs = [
    {
      id: 0,
      label: intl.formatMessage({ id: `app.contract.purchase.overview` }),
      to: props.match.url,
    },
    {
      id: 1,
      label: intl.formatMessage({ id: `app.contract.purchase.contractParams` }),
      to: `${props.match.url}/parameters`,
    },
    {
      id: 2,
      label: intl.formatMessage({ id: `app.contract.purchase.tabLabel` }),
      to: `${props.match.url}/buy`,
    },
  ];

  const { getContract, data: getData } = useGetContract();
  const { getContractExport, data: exportData, error: exportError } = useGetContractExport();

  // local state
  const [info, setInfo] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);
  const [contractRouterProps, setContractRouterProps] = useState(props);
  const [contractTabs, setContractTabs] = useState(tabs);

  // preselect tab based on URL
  useEffect(() => {
    setSelectedTab(tabs.filter((item) => item.to === props.location.pathname)[0].id);
  }, [props.location.pathname, tabs]);

  useEffect(() => {
    (async () => {
      await getContract(props.match.params.contractId);
    })();
  }, [getContract, props.match.params.contractId]);

  useEffect(() => {
    if (getData) {
      setInfo({
        headline: `${intl.formatMessage({ id: 'app.contract.purchase.detail' })} ${getData.commodity.name} ${getData.contractPeriod}`,
        id: `#${getData.idExternal}`,
      });
      setContractRouterProps({
        ...props,
        contractData: getData,
      });

      if (getData.isFix) {
        setContractTabs((tabs) => {
          return tabs.map((tab) => {
            const newTab = { ...tab };
            if (newTab.id === 2) {
              newTab.label = intl.formatMessage({ id: `app.contract.sale.tabLabel` });
            }
            return newTab;
          });
        });
      }
    }
  }, [getData, props, intl]);

  return (
    <Container maxWidth="xl">
      <div>
        {!contractRouterProps.contractData && <ContentLoader type={'PAGE'} />}
        {contractRouterProps.contractData && (
          <>
            <Box pt={6} pb={4}>
              <StyledHeader>
                <h1>{info.headline}
                  <FileExport
                    getAllEntityExport={getContractExport}
                    tooltip={<FormattedMessage id="app.contract.export" />}
                    fileName={intl.formatMessage({ id: 'app.contract.export.filename' })}
                    data={exportData}
                    searchQuery={props.match.params.contractId}
                    exportError={exportError}
                    key={'toolbar-file-export'}
                  />
                </h1>
                <h2>
                  {info.id} - {contractRouterProps?.contractData?.customer?.name}
                </h2>
              </StyledHeader>
            </Box>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(event, value) => setSelectedTab(value)}
              variant="scrollable"
              scrollButtons="auto"
            >
              {contractTabs.map((item, key) => {
                return <Tab key={key} label={item.label} component={Link} to={item.to} />;
              })}
            </Tabs>
            <Box pt={4} pb={2}>
              <ContractRouter {...contractRouterProps} getContract={getContract} />
            </Box>
          </>
        )}
      </div>
    </Container>
  );
};

Contract.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Contract;
